module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-12.aaa3295f.png";